function initCartUpsellSlider() {
  var $slider = $('[data-slick-slider]');
  
  if ($slider.length) {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    

    $slider.slick({
      dots: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      prevArrow: $('.prev-button'),
      nextArrow: $('.next-button'),
      responsive: [
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
}


$(document).ready(function() {
  initCartUpsellSlider();
  setupCartDrawerObserver();
});


function setupCartDrawerObserver() {
 
  var cartTarget = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer') || document.getElementById('CartDrawer');
  
  if (cartTarget) {
    var observer = new MutationObserver(function(mutations) {
      
      var $slider = $('[data-slick-slider]');
      if ($slider.length && !$slider.hasClass('slick-initialized')) {
        setTimeout(function() {
          initCartUpsellSlider();
        }, 100);
      }
    });
    
    observer.observe(cartTarget, { childList: true, subtree: true });
  }
}

$(document).ajaxComplete(function(event, xhr, settings) {
  if (settings.url && (settings.url.indexOf('/cart') !== -1)) {
    setTimeout(initCartUpsellSlider, 500);
  }
});